import { render, staticRenderFns } from "./inspectionDetail.vue?vue&type=template&id=0c078673&scoped=true&"
import script from "./inspectionDetail.vue?vue&type=script&lang=ts&"
export * from "./inspectionDetail.vue?vue&type=script&lang=ts&"
import style0 from "./inspectionDetail.vue?vue&type=style&index=0&id=0c078673&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c078673",
  null
  
)

export default component.exports